<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <br />
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
let self = {};
export default {
  name: "TableCvmResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      columns: [
        {
          title: this.$t("RAM.TENCENT.CVM.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.TENCENT.CVM.instanceId"),
          key: "instanceId"
        },
        {
          title: this.$t("RAM.TENCENT.CVM.name"),
          key: "name"
        },
        {
          title: this.$t("RAM.TENCENT.CVM.region"),
          key: "regionName"
        },
        {
          title: this.$t("RAM.TENCENT.CVM.instanceType"),
          key: "instanceType"
        },
        {
          title: this.$t("RAM.TENCENT.CVM.cpu"),
          key: "cpu"
        },
        {
          title: this.$t("RAM.TENCENT.CVM.ram"),
          key: "ram"
        },
        {
          title: this.$t("RAM.TENCENT.CVM.os"),
          key: "os"
        },
        {
          title: this.$t("RAM.TENCENT.CVM.stateName"),
          key: "stateName"
        },
        {
          title: this.$t("RAM.TENCENT.CVM.publicIp"),
          key: "publicIp"
        },
        {
          title: this.$t("RAM.TENCENT.CVM.privateIp"),
          key: "privateIp"
        },
        {
          title: this.$t("RAM.TENCENT.CVM.instanceCreatedTime"),
          key: "instanceCreatedTime"
        }
      ],
      tableData: []
    };
  },
  created() {
    this._handleCompanyId = val => { this.companyId = val; };
    this._handleAccountSearchKey = val => { this.accountSearchKey = val; };
    this._handleAccountName = val => { this.accountName = val; };
    this._handleInstanceId = val => { this.instanceId = val; };
    this._handlePrivateIp = val => { this.privateIp = val; };
    eventBus.$on("companyId", this._handleCompanyId);
    eventBus.$on("accountSearchKey", this._handleAccountSearchKey);
    eventBus.$on("accountName", this._handleAccountName);
    eventBus.$on("instanceId", this._handleInstanceId);
    eventBus.$on("privateIp", this._handlePrivateIp);
    self = this;
  },
  methods: {
    showAll() {
      self.current = 1;
      self.getData();
    },
    getData() {
      self.$api.resourceManagement
        .selectTencentCvmByPage({
          companyId: self.companyId,
          accountName: self.accountName,
          instanceId: self.instanceId,
          privateIp: self.privateIp,
          accountIdList: self.accountSearchKey,
          pageNum: self.current,
          pageSize: self.pageSize
        })
        .then(res => {
          this.tableData = res.data.records;
          this.current = res.data.current;
          this.dataTotal = res.data.total;
        });
    },
    changePage(current) {
      this.current = current;
      this.getData();
    },
    changeSize(pageSize) {
      this.pageSize = pageSize;
      this.getData();
    }
  },
  beforeDestroy() {
    eventBus.$off("companyId", this._handleCompanyId);
    eventBus.$off("accountSearchKey", this._handleAccountSearchKey);
    eventBus.$off("accountName", this._handleAccountName);
    eventBus.$off("instanceId", this._handleInstanceId);
    eventBus.$off("privateIp", this._handlePrivateIp);
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/tencent/cvm/TableCvmResource.vue